import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { DatePicker } from 'antd';
import dayjs from 'dayjs'
import common from '../common.module.css'

export const Date = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    const onChange = (date, dateString) => {
      setFieldInState({field: 'date_conference', value: dateString})
    };
    
    return (
      <DatePicker 
        value={state.date_conference ? dayjs(state.date_conference, 'YYYY-MM-DD') : null}
        className={common.antd}
        onChange={onChange} />
    );
}